import React from 'react';

import LandingButton from './../../components/LandingButton.js'
import Header from './../../components/Header.js'

import './Landing.css';

function Landing() {
  return (
      <div class="landing">
          <div class="photo">
            <img class="photo" src="https://i.pinimg.com/originals/e1/48/3c/e1483c7b75c486d124d9d1f1a70ea429.png" alt="flush"/>
          </div>

          <div class="text-container">
            <h1> STAT 198 </h1>
            <h2> Introduction to Poker </h2>

            <div style={{height: '40px'}} />

            <p><b>Instructors: </b> Kevin An, Aidan Reilly</p>

            <h3>Lectures</h3>
            <ul>
                <li>Mondays, 7PM – 8PM</li>
                <li>Wednesdays, 7PM – 8PM</li>
            </ul>

            <h3>Playing Sessions</h3>
            <ul>
                <li>Mondays, 8PM – 9PM</li>
                <li>Wednesdays, 8PM – 9PM</li>
            </ul>

            <div style={{height: '40px'}} />

            <h2>Announcements</h2>
            <p>Week 2 - <a style={{"color": "mediumseagreen"}} href="https://docs.google.com/document/d/1msTXZ98MQNJI-k_TeA-ivE3O9KgyWa74/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">HW 1 just released</a> and due on September 27th (Monday) </p>
            <p>Week 5 - <a style={{"color": "mediumseagreen"}} href="https://docs.google.com/document/d/14HHnxidC6uTCevOWKbY0aTXQOelzDjQO/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">HW 2 just released</a> and due on October 13th (Wednesday) </p>


            <div style={{height: '40px'}} />

            <h2>Syllabus</h2>
            <div style={{height: '15px'}} />
            <table>
                <thead>
                    <tr>
                    <th style={{"minWidth": "50px"}}></th>
                    <th>Topic</th>
                    <th>Lectures</th>
                    <th>.ppt</th>
                    <th>Recordings</th>
                    <th>Homework</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>Introduction to Poker</td>
                        <td style={{"textAlign": "left"}}>
                            <p>Course Logistics, Rules of Poker, Game Theory: Optimal Play vs. Exploitative Play</p>
                            <p><b>Reading: </b> How to Study Poker</p>
                        </td>
                        <td><a href="https://docs.google.com/presentation/d/11v9qxP3wXYmwamWTRNhnk_ynH5sUQS2I/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">Slides</a></td>
                        <td><a href="https://www.youtube.com/watch?v=ez8znTfHUF8&list=PL8MAs54Q46zcD6zS4sJ-YxbAx1xI-q5F2&index=1">9/8/2021</a></td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>Introduction to Poker</td>
                        <td style={{"textAlign": "left"}}>
                            <p>Expected Value, Mental Game, How to Study Poker, Common Terms, Math of Draws, Pot Odds</p>
                        </td>
                        <td><a href="https://docs.google.com/presentation/d/1E-9eydmPn5PLJGyu8VMq3_1d5OuzCoXW/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">Slides</a></td>
                        <td><a href="https://youtu.be/zFGHPS6thkw">9/13/2021</a></td>
                        <td><a href="https://docs.google.com/document/d/1msTXZ98MQNJI-k_TeA-ivE3O9KgyWa74/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">HW 1</a></td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>Introduction to Theory</td>
                        <td style={{"textAlign": "left"}}>
                            <p>Implied Odds, Ranking Preflop Hand Strength, Position, Opening Preflop, Preflop Play from UTG</p>
                        </td>
                        <td><a href="https://docs.google.com/presentation/d/1AAdVLo0HzIQEqc_YIvW6PjpFwxDK3cp3/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">Slides</a></td>
                        <td><a href="https://youtu.be/CQsJWLtejag">9/15/2021</a></td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Preflop Play</td>
                        <td style={{"textAlign": "left"}}>
                            <p>Preflop Opening Ranges (continued), Limping, Pot Equity, Fold Equity, VPIP, PFR</p>
                            <p><b>Reading: </b> More on Ranges in Poker</p>
                        </td>
                        <td><a href="https://docs.google.com/presentation/d/1FWAorzocg5WdIlWQhER_3SfzSBw4y4gE/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">Slides</a></td>
                        <td><a href="hhttps://www.youtube.com/watch?v=V0GnOocWIrE&list=PL8MAs54Q46zcD6zS4sJ-YxbAx1xI-q5F2&index=4">9/20/2021</a></td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Preflop Play</td>
                        <td style={{"textAlign": "left"}}>
                            <p>Preflop (continued), Exploitative Play, Stealing the Blinds, Vacuum and Long-term Expected Value, Calling Opens</p>
                            <p><b>Reading: </b> Mathematics of Betting and Pot Odds</p>
                        </td>
                        <td><a href="https://docs.google.com/presentation/d/1eWkxOYDiXcDOjYViwVeE_D2woDtLylba/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">Slides</a></td>
                        <td><a href="https://www.youtube.com/watch?v=lhCDDIBoUtY&list=PL8MAs54Q46zcD6zS4sJ-YxbAx1xI-q5F2&index=5">9/22/2021</a></td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Continuation Betting</td>
                        <td style={{"textAlign": "left"}}>
                            <p>Review, Isolation Raising, 3-betting, Linear Ranges, 4-betting, Defense Frequency, Range Narrowing</p>
                        </td>
                        <td><a href="https://docs.google.com/presentation/d/1x8PVm52PcUtnuZRAmgUAMi4f_N35F92G/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">Slides</a></td>
                        <td><a href="https://www.youtube.com/watch?v=LqJW3vVJcXw&list=PL8MAs54Q46zcD6zS4sJ-YxbAx1xI-q5F2&index=6">9/27/2021</a></td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Continuation Betting</td>
                        <td style={{"textAlign": "left"}}>
                            <p>Postflop Play, Continuation Betting, Board Textures on the Flop, Equity and C-Betting, C-Bet Bluffing, Implied & Reverse Implied Odds from the Flop, Showdown Value, C-Bet Sizing</p>
                        </td>
                        <td><a href="https://docs.google.com/presentation/d/1zqTLQj3wMEVZYz4JhHSD1ZeyaGsPmt9g/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">Slides</a></td>
                        <td><a href="https://www.youtube.com/watch?v=LqJW3vVJcXw&list=PL8MAs54Q46zcD6zS4sJ-YxbAx1xI-q5F2&index=7">9/29/2021</a></td>
                        <td><a href="https://docs.google.com/document/d/14HHnxidC6uTCevOWKbY0aTXQOelzDjQO/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">HW 2</a></td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>Value Betting</td>
                        <td style={{"textAlign": "left"}}>
                            <p>C-Betting for Value</p>
                        </td>
                        <td><a href="https://docs.google.com/presentation/d/13DvgeGh55D9mVjMzscKxpCjAu45QA8Zz/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">Slides</a></td>
                        <td>10/4/2021</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>Value Betting</td>
                        <td style={{"textAlign": "left"}}>
                            <p>Value Bets on the River</p>
                        </td>
                        <td><a href="https://docs.google.com/presentation/d/14slQmt5pp0_vcrGrpGRop3Mw2Ndz0zSq/edit?usp=sharing&ouid=107578910237958097214&rtpof=true&sd=true">Slides</a></td>
                        <td>10/6/2021</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>Value & Continutation Betting</td>
                        <td style={{"textAlign": "left"}}></td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>Value & Continutation Betting (continued)</td>
                        <td style={{"textAlign": "left"}}></td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td>Facing Bets</td>
                        <td style={{"textAlign": "left"}}></td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td>3 Betting</td>
                        <td style={{"textAlign": "left"}}></td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td>Bluffing on Later Streets</td>
                        <td style={{"textAlign": "left"}}></td>
                    </tr>
                    <tr>
                        <td>11</td>
                        <td>3-Bet Pots and Stack Depth</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>12</td>
                        <td>Course End</td>
                        <td style={{"textAlign": "left"}}>Concluding Examples, Reads, Tells, Poker Psychology, Mental Game</td>
                    </tr>
                </tbody>
            </table>

            <div style={{height: '40px'}} />

            <a href="https://www.ocf.berkeley.edu">
                <img src="https://www.ocf.berkeley.edu/hosting-logos/ocf-hosted-penguin.svg"
                    alt="Hosted by the OCF" style={{"border": 0}}/>
            </a>

            <div style={{height: '100px'}} />

        </div>
      </div>
  );
}

export default Landing;
